var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReportList"},[_c('h2',{staticStyle:{"font-size":"24px","color":"#262626","font-weight":"bold"}},[_vm._v("游戏报告")]),_c('div',{staticClass:"reportView"},[_c('div',[_c('a-tabs',{attrs:{"defaultActiveKey":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"个体报告"}},[_c('game-personal-report')],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }